import BaseMapper from '../../BaseMapper';

const DescriptionMapper = (data, context) => {
    return data;
};

export default DescriptionMapper;
